<template>
  <el-dialog
    width="360px"
    :title="title"
    :visible="visible"
    @close="cancel"
    class="gcp-settings-modal"
  >
    <div class="gcp-settings">
      <div class="gcp-settings__container">
        <div class="gcp-settings__content">
          <div class="gcp-settings__block" v-if="!state.multi">
            <r-title type="subtitle-2" style="margin-bottom: 8px;">
              Номер
            </r-title>
            <div class="gcp-settings__block-container">
              <el-input-number
                class="r-input number"
                :controls="false"
                v-model="no"
              />
            </div>
          </div>
          <div class="gcp-settings__block" v-if="!isLink">
            <r-title type="subtitle-2" style="margin-bottom: 8px;">
              Тип
            </r-title>
            <div class="gcp-settings__block-container">
              <el-select
                class="r-select"
                placeholder="Выберите тип"
                size="mini"
                :popper-append-to-body="false"
                popper-class="r-select__popper"
                v-model="type"
                value-key="id"
                :disabled="state.mode === 'edit' && isNotEmpty"
              >
                <el-option
                  v-for="item in gcpTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="gcp-settings__block">
            <r-title type="subtitle-2" style="margin-bottom: 8px;">
              Временной интервал
            </r-title>
            <div class="gcp-settings__block-container">
              <el-select
                class="r-select"
                placeholder="Выберите интервал"
                size="mini"
                :popper-append-to-body="false"
                popper-class="r-select__popper"
                v-model="interval"
                value-key="id"
                @change="intervalChanged"
                :disabled="state.mode === 'edit' && isNotEmpty"
              >
                <el-option
                  v-for="item in gcpIntervals"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>

            <div
              class="gcp-settings__block-subcontainer"
              v-if="interval && interval.id === 1"
            >
              <div>
                <r-text type="caption">
                  Укажите начало интервала
                </r-text>
                <div class="gcp-settings__hour-interval">
                  <el-time-select
                    class="r-time-picker r-input"
                    v-model="hourStartValue"
                    :picker-options="{
                      start: '00:00',
                      step: '01:00',
                      end: '23:00'
                    }"
                    popper-class="r-select__popper"
                    :clearable="false"
                  />
                  <r-text>-</r-text>
                  <el-time-select
                    class="r-time-picker r-input"
                    v-model="hourStartValue"
                    :picker-options="{
                      start: '00:00',
                      step: '01:00',
                      end: '23:00'
                    }"
                    popper-class="r-select__popper"
                    disabled
                  />
                </div>
              </div>
              <div class="gcp-settings__hour-breaks">
                <r-text type="caption">
                  Почасовая детализация
                </r-text>
                <el-checkbox class="r-checkbox" v-model="hourBreaks" />
              </div>
            </div>
            <div
              class="gcp-settings__block-subcontainer"
              v-else-if="interval && interval.id === 2"
            >
              <r-text type="caption">
                Укажите интервалы
              </r-text>
              <el-select
                class="r-select"
                placeholder="Интервалы"
                size="mini"
                :popper-append-to-body="false"
                popper-class="r-select__popper"
                v-model="hourInterval"
                value-key="value"
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in hourIntervals"
                  :key="item.value"
                  :label="item.name"
                  :value="item"
                  :disabled="isDisabledHourInterval(item)"
                >
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>
            <div
              class="gcp-settings__block-subcontainer"
              v-else-if="interval.id === 3"
            >
              <div class="gcp-settings__block-subtitle">
                <r-text type="caption">
                  Укажите интервалы
                </r-text>
                <el-button
                  class="r-button green circle small"
                  @click="addMinuteInterval"
                  size="mini"
                  type="success"
                  icon="el-icon-plus"
                  circle
                />
              </div>
              <div class="gcp-settings__minute-intervals">
                <div
                  class="gcp-settings__minute-interval"
                  v-for="item in minuteIntervals"
                  :key="item.id"
                >
                  <el-time-select
                    class="r-time-picker"
                    v-model="item.start_interval"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:45'
                    }"
                    popper-class="r-select__popper"
                    @change="minuteIntervalChangeHandler(item, $event)"
                    :clearable="false"
                  />
                  <r-text>-</r-text>
                  <el-time-select
                    class="r-time-picker"
                    v-model="item.end_interval"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:45'
                    }"
                    popper-class="r-select__popper"
                    disabled
                  />
                  <div
                    class="gcp-settings__interval-close"
                    @click="removeMinuteInterval(item)"
                  >
                    <r-icon type="additional" name="close" :size="8" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gcp-settings__warning">
        <el-alert
          v-if="state.mode === 'edit' && isNotEmpty"
          title="Редактирование ограничено"
          type="warning"
          description="По данному перекрестку ранее уже были занесены результаты замеров.
            Редактирование установленного типа замеров и типа временного интервала невозможно."
          show-icon
          effect="dark"
          :closable="false"
        />
      </div>
    </div>
    <div slot="footer" class="gcp-settings__actions">
      <el-button
        class="r-button danger"
        type="danger"
        size="mini"
        @click="deleteObject"
      >
        Удалить
      </el-button>
      <el-button
        class="r-button"
        type="primary"
        size="mini"
        @click="save"
        :disabled="!isSaveAvailable"
      >
        Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Constants } from "@/libs/map-draw/lib-utils";
import { clearAllHelpers } from "@/libs/map-draw/helpers";
import { gcpTypes, gcpIntervals, hourIntervals } from "../../configs";

export default {
  props: ["state", "draw", "mapgl", "visible"],
  data() {
    return {
      no: 1,
      type: gcpTypes[0],
      gcpTypes,
      interval: gcpIntervals[0],
      gcpIntervals,
      hourStartValue: "00:00",
      hourBreaks: false,
      hourInterval: [],
      hourIntervals,
      minuteIntervals: [],
      isNotEmpty: true
    };
  },
  computed: {
    title() {
      return this.state.multi
        ? `Свойства general_count_points (${this.state.multiFeatures.length})`
        : "Свойства general_count_point";
    },
    isLink() {
      return (
        this.state.currentGCPoint &&
        this.state.currentGCPoint.properties.link_id
      );
    },
    isSaveAvailable() {
      if (this.type && this.interval) {
        if (this.interval.value === 60 && !this.hourInterval.length)
          return false;
        if (this.interval.value === 15 && !this.minuteIntervals.length)
          return false;
        return true;
      }

      return false;
    },
    disabledIndexes() {
      const disabledIndexes = [];
      this.hourInterval.forEach(item => {
        const index = this.hourIntervals.findIndex(i => i === item);
        disabledIndexes.push(index - 1);
        disabledIndexes.push(index + 1);
      });
      return disabledIndexes;
    }
  },
  watch: {
    "state.currentGCPoint": function(val) {
      if (!val) return;
      this.setInitialValue(val);
    }
  },
  methods: {
    isDisabledHourInterval(value) {
      const initialIndex = this.hourIntervals.findIndex(i => i === value);

      return this.disabledIndexes.indexOf(initialIndex) > -1;
    },
    intervalChanged() {
      this.hourInterval = [];
      this.minuteIntervals = [];
    },
    addMinuteInterval() {
      let start_interval = "00:00";
      let end_interval = "00:15";

      const getNextInterval = value => {
        const [start, end] = value.split(":").map(s => Number(s));

        if (end === 45) return `${start === 23 ? "00" : start + 1}:00`;
        else return `${start}:${end + 15}`;
      };

      if (this.minuteIntervals.length) {
        const { length } = this.minuteIntervals;

        start_interval = this.minuteIntervals[length - 1].end_interval;
        end_interval = getNextInterval(start_interval);
      }

      this.minuteIntervals.push({
        id: Date.now(),
        start_interval,
        end_interval
      });
    },
    removeMinuteInterval(interval) {
      this.minuteIntervals = this.minuteIntervals.filter(i => i !== interval);
    },
    minuteIntervalChangeHandler(interval, value) {
      const [start, end] = value.split(":").map(s => Number(s));
      if (end === 45)
        interval.end_interval = `${start === 23 ? "00" : start + 1}:00`;
      else interval.end_interval = `${start}:${end + 15}`;
    },
    getHourBreaks() {
      const start = parseInt(this.hourStartValue.split(":")[0]);
      const endValues = [];
      const startValues = [];

      for (let i = 0; i <= start; i++) {
        const first = String(i).length > 1 ? i : `0${i}`;
        const second = String(i + 1).length > 1 ? i + 1 : `0${i + 1}`;
        endValues.push({
          start_interval: `${first}:00`,
          end_interval: `${second}:00`
        });
      }

      for (let i = start + 1; i <= 23; i++) {
        const first = String(i).length > 1 ? i : `0${i}`;
        let second;
        if (i !== 23) second = String(i + 1).length > 1 ? i + 1 : `0${i + 1}`;
        else second = "00";
        startValues.push({
          start_interval: `${first}:00`,
          end_interval: `${second}:00`
        });
      }

      return [...startValues, ...endValues];
    },
    getIntervals() {
      const intervals = [];

      switch (this.interval.value) {
        case 86400:
          if (this.hourBreaks) return this.getHourBreaks();
          return [
            {
              start_interval: this.hourStartValue,
              end_interval: this.hourStartValue
            }
          ];
        case 60:
          return this.hourInterval.map(i => ({
            start_interval: i.name.split(" - ")[0],
            end_interval: i.name.split(" - ")[1],
            id: i.id || undefined
          }));
        case 15:
          this.minuteIntervals.forEach(interval => {
            const index = intervals.findIndex(
              i => i.start_interval === interval.start_interval
            );
            if (index === -1) intervals.push(interval);
          });
          return intervals.map(({ start_interval, end_interval }) => ({
            start_interval,
            end_interval
          }));
      }
    },
    cancel() {
      const {
        currentGCPoint,
        tcSettingsMode,
        multi,
        multiFeatures
      } = this.state;

      if (multi) {
        this.draw.delete(multiFeatures.map(f => f.id));
        this.$set(this.state, "multiFeatures", []);
      } else {
        if (currentGCPoint && tcSettingsMode === "create")
          this.draw.delete(this.state.currentGCPoint.id);
        if (currentGCPoint && tcSettingsMode === "edit")
          this.draw.changeMode("traffic_counts_simple_select", {
            featureIds: []
          });
      }

      clearAllHelpers(this.mapgl);
      this.$emit("close");
    },
    deleteObject() {
      const { currentGCPoint, multi, multiFeatures } = this.state;

      clearAllHelpers(this.mapgl);

      if (multi) {
        this.draw.delete(multiFeatures.map(f => f.id));
        this.$set(this.state, "multiFeatures", []);
      } else {
        this.draw.delete(currentGCPoint.id);
        this.mapgl.fire(Constants.events.DELETE, {
          features: [currentGCPoint.toGeoJSON()]
        });
      }

      this.$emit("close");
    },
    save() {
      const { multi, multiFeatures } = this.state;

      if (multi) {
        multiFeatures.forEach(f => {
          f.setProperty("interval_type", this.interval.value);
          f.setProperty("detalization_type", this.type.value);
          f.setProperty("measure_intervals", this.getIntervals());
        });
        this.mapgl.fire(Constants.events.CREATE, {
          features: multiFeatures.map(f => f.toGeoJSON())
        });
        this.draw.changeMode(Constants.modes.SIMPLE_SELECT, {
          featureIds: []
        });
        this.$set(this.state, "multiFeatures", []);
      } else {
        const { currentGCPoint, editingCallback } = this.state;

        currentGCPoint.setProperty("no", this.no);
        currentGCPoint.setProperty("interval_type", this.interval.value);
        currentGCPoint.setProperty("detalization_type", this.type.value);
        currentGCPoint.setProperty("measure_intervals", this.getIntervals());
        editingCallback(currentGCPoint);
        this.draw.changeMode("traffic_counts_simple_select", {
          featureIds: []
        });
      }

      this.$emit("close");
    },
    setInitialValue(point) {
      const { properties } = point;
      const {
        no,
        detalization_type,
        interval_type,
        measure_intervals,
        measure_count
      } = properties;

      this.no = no;
      this.type = this.gcpTypes.find(t => t.value === detalization_type);
      this.interval = this.gcpIntervals.find(i => i.value === interval_type);
      this.isNotEmpty = !!measure_count;

      switch (interval_type) {
        case 86400:
          break;
        case 60:
          this.hourInterval = measure_intervals.map(int => {
            const interval = this.hourIntervals.find(
              i =>
                int.start_interval === `${i.name.split(" - ")[0]}:00` &&
                int.end_interval === `${i.name.split(" - ")[1]}:00`
            );

            return {
              ...int,
              name: interval.name,
              value: interval.value
            };
          });
          break;
        case 15:
          this.minuteIntervals = measure_intervals;
          break;
      }
    }
  },
  created() {
    const { tcSettingsMode, currentGCPoint } = this.state;

    if (tcSettingsMode === "edit") {
      this.setInitialValue(currentGCPoint);
    }
  }
};
</script>

<style lang="scss" src="./gcp-settings.scss"></style>
